// extracted by mini-css-extract-plugin
export default {"flexbox":"Landing_flexbox__CL-PO","conteneur_Texte":"Landing_conteneur_Texte__9iqY1","text_accent":"Landing_text_accent__hau8G","paragraphe":"Landing_paragraphe__AVHCD"};